export enum Interviewtype{
   
    HrInterview = 'HR Interview',
}